<template>
  <div id="footer">
    <!-- <div class="nav-top" v-show="is_login">
      <router-link to="/">首页</router-link>
      <span class="sep">|</span>
      <router-link to="/Ranking">排行榜</router-link>
      <span class="sep">|</span>
      <router-link to="/User">用户中心</router-link>
      <span class="sep">|</span>
      <router-link to="/Agency">代理商</router-link>
      <span class="sep">|</span>
      <router-link to="/Card">办卡管理</router-link>
      <span class="sep">|</span>
      <router-link to="/Loan">贷款管理</router-link>
      <span class="sep">|</span>
      <router-link to="/Profit">分润查询</router-link>
      <span class="sep">|</span>
      <router-link to="/Award">奖励制度</router-link>
      <span class="sep">|</span>
      <router-link to="/Promo">推广码</router-link>
    </div> -->
    <!-- <div class="info-box">
      <div class="qr-code"><img src="../../../static/images/qr-code.png" alt=""></div>
      <div class="info">
        <p class="name">苏州君宝有限公司</p>
        <p class="address">地址：苏州市高新区滨河路687号工业大厦4F</p>
      </div>
    </div> -->
    <div class="nav-top clearfix">
      <div class="nav-left fleft">
        <ul class="nav-link">
          <li>
            <dl>
              <dt><router-link to="/About">关于我们</router-link></dt>
              <dd><router-link to="/About">企业简介</router-link></dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt><a href="javascript:;">产品服务</a></dt>
              <dd><a href="javascript:;">业务合作</a></dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt><a href="javascript:;">联系方式</a></dt>
              <dd><a href="javascript:;">0512-65359917</a></dd>
            </dl>
          </li>
          <li>
            <dl>
              <dt><a href="javascript:;">加入我们</a></dt>
            </dl>
          </li>
        </ul>
      </div>
      <div class="nav-right fleft">
        <div class="nav-qr">
          <img src="../../../static/images/qr-code.png" alt="">
        </div>
        <div class="nav-name">易卡多金融</div>
      </div>
      <div class="fright nav-address">公司地址：苏州市高新区滨河路687号工业大厦4F</div>
    </div>
    <div class="nav-bottom">
      <ul>
        <li><img src="../../../static/images/eoao.png" alt=""></li>
        <li><img src="../../../static/images/dmbu.png" alt=""></li>
        <li><img src="../../../static/images/xpwx.png" alt=""></li>
        <li><img src="../../../static/images/e9k2.png" alt=""></li>
      </ul>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  name: "Footer",
  data() {
    return {
      is_login: false
    };
  },
  created() {},
  methods: {
    showNav() {
      this.is_login = true;
    },
    hideNav() {
      this.is_login = false;
    }
  },
  components: {}
};
</script>
<style lang="stylus" scoped>
#footer
  position relative
  width 100%
  background #323232
  .nav-top
    width 1336px
    margin 0 auto
    padding 30px 0
    .nav-link
      display flex
      width 968px
      li
        flex 1
        a
          color #fff
        dt
          font-size 16px
          margin-bottom 20px
        dd
          margin-bottom 10px
          font-size 12px
          a
            color #dadada
  .nav-right
    position relative
    width 200px
    text-align center
    color #fff
    border-left 1px solid #fff
    .nav-qr
      margin-bottom 10px
  .nav-address
    width 166px
    color #fff
    line-height 2
  .nav-bottom
    position relative
    width 100%
    ul
      width 60%
      margin 20px auto
      border-top 1px solid rgb(90, 90, 90)
      text-align center
      li
        display inline-block
        width 136px
        height 46px
        margin-top 20px
        margin-right 15px
        margin-bottom 20px
        overflow hidden
        img
          width 100%
          height 100%
</style>




// WEBPACK FOOTER //
// src/components/footer/footer.vue